import React from 'react';
import Translate from 'react-translate-component';

import { mapIndexed } from 'utils/ramdaAdditions';
import { getValueFromDictBy } from 'helpers/fieldsHelpers';

const getLanguageName = getValueFromDictBy('id', 'name');

const RequestLanguages = ({ languages, options }) => languages && options ? (
    <span>
        { mapIndexed((language, index) => (
            <span key={ index }>
                <span className="language-name">{ getLanguageName(language.id, options) }</span>
                { !!language.level &&
                    <span>
                        &nbsp;
                        (<Translate
                            className="language-level"
                            content={ "common.language_level." + language.level }
                            component="span"
                        />)
                    </span>
                }
                { index < languages.length - 1 &&
                    <span>, </span>
                }
            </span>
        ), languages)}
    </span>
) : null;

export default RequestLanguages;
